import { render, staticRenderFns } from "./PortalErrorDetails.vue?vue&type=template&id=dd2f5e34&scoped=true&"
import script from "./PortalErrorDetails.vue?vue&type=script&lang=js&"
export * from "./PortalErrorDetails.vue?vue&type=script&lang=js&"
import style0 from "./PortalErrorDetails.vue?vue&type=style&index=0&id=dd2f5e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2f5e34",
  null
  
)

export default component.exports